<nav class="dd-top-nav-container secondary-shadow ">
  <div class="topnav-left">
    <div class="topnav-logo-container">
      <ng-content select="[ddlogo]"></ng-content>
    </div>
    <div class="topnav-links-container">
      <ng-content select="[ddlinks]"></ng-content>
    </div>
  </div>
  <div class="topnav-right">
    <ng-content select="[ddactions]"></ng-content>
  </div>
</nav>
